import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardEmptyFirstPlace = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 88,
  height: 118,
  viewBox: "0 0 88 118",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("rect", {
    width: 87.407,
    height: 102.664,
    x: 0.302,
    y: 15.336,
    fill: "#CCF88E",
    rx: 12.837
  }), /*#__PURE__*/_jsx("circle", {
    cx: 44.01,
    cy: 23.489,
    r: 18.794,
    fill: "#274A34"
  }), /*#__PURE__*/_jsx("circle", {
    cx: 44.01,
    cy: 23.489,
    r: 18.794,
    fill: "#274A34"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#274A34",
    d: "M58.546 58.538c.488 2.44-1.925 4.447-4.235 3.523l-9.13-3.652a3.13 3.13 0 0 0-2.326 0l-9.13 3.652c-2.31.924-4.723-1.083-4.235-3.522l2.812-14.064c.213-1.062 1.417-1.595 2.398-1.133a21.84 21.84 0 0 0 9.318 2.072c3.332 0 6.49-.743 9.318-2.073.98-.46 2.185.072 2.397 1.134z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#CCF88E",
    d: "m39.55 17.348 6.49-2.43V32.96h-3.934V20.255l-2.556 1.027z"
  })]
});
export default SvgLeaderboardEmptyFirstPlace;